import React from "react";
import {
  Button,
  Grid,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";
import { dateFormate, truncateComment } from "utils/utils";
import mailIcon from 'assets/images/MailLogo.svg'
import callIcon from "assets/images/customerCall.svg";
import locationIcon from "assets/images/locationLogo.svg";
import calender from "assets/images/Calender.svg";
import OfficeBlue from "assets/images/OfficeBlue.svg";

function CustomerSubHeaderDetails(props) {
  const details = props?.details;
  return (
    <Grid className="customerAbout height270 overflowCard">
      <Grid
        item
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        xs={12}
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="width100"
        >
          <Grid>
            <Typography
              className="fontBold font16"
              variant="h4"
              style={{paddingBottom: "15px", paddingTop: "10px"}}
            >
              About
            </Typography>
          </Grid>

          <Grid item>
            <Button variant="contained" className="vendorEditBtn">
              <span></span>
            </Button>
          </Grid>
        </Grid>

        {/* Email Section */}
        <Grid item className="aboutCard width100">
          {props?.loader ? (
            <Skeleton animation="wave" width={200} height={50} />
          ) : (
            <Grid 
              container 
              direction="row" 
              alignItems="center" 
              className="marginLeft15 subHeaderCardEmail mb15"
              wrap="nowrap"
            >
              <Grid item style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                <img src={mailIcon} alt="mail icon" />
              </Grid>
              <Grid item style={{ flex: 1, minWidth: 0 }}>
                <Tooltip title={details?.email || "Not Available"} arrow>
                  <Typography 
                    className="font16" 
                    style={{ 
                      overflow: 'hidden', 
                      textOverflow: 'ellipsis', 
                      whiteSpace: 'nowrap' 
                    }}
                  >
                    {details?.email ? details?.email : "Not Available"}
                  </Typography>
                </Tooltip>
              </Grid>
            </Grid>
          )}
        </Grid>

        {/* Phone Section */}
        <Grid item className="width100">
          {props?.loader ? (
            <Skeleton animation="wave" width={200} height={50} />
          ) : (
            <Grid 
              container 
              direction="row" 
              alignItems="center" 
              className="marginLeft15 subHeaderCard mb15"
              spacing={1}
            >
              <Grid item>
                <img src={callIcon} alt="callIcon" className="ml15" />
              </Grid>
              <Grid item xs className="font16 textBreak">
                {details?.phoneNumber ? `${details?.countryCode} ${details?.phoneNumber}` : "Not Available"}
              </Grid>
            </Grid>
          )}
        </Grid>

        {/* Location Section */}
        <Grid item className="width100">
          {props?.loader ? (
            <Skeleton animation="wave" width={200} height={50} />
          ) : (
            <Grid 
              container 
              direction="row" 
              alignItems="center" 
              className="marginLeft15 subHeaderCard mb15"
              spacing={1}
            >
              <Grid item>
                <img src={OfficeBlue} alt="companyName" className="ml15" />
              </Grid>
              <Grid item xs className="font16 textBreak">
                {details?.companyName ? details?.companyName : "Not Available"}
              </Grid>
            </Grid>
          )}
        </Grid>

        {/* Date Section */}
        <Grid item className="width100">
          {props?.loader ? (
            <Skeleton animation="wave" width={200} height={50} />
          ) : (
            <Grid 
              container 
              direction="row" 
              alignItems="center" 
              className="marginLeft15 subHeaderCard mb15"
              spacing={1}
            >
              <Grid item>
                <img src={calender} alt="calender" className="ml15" />
              </Grid>
              <Grid item xs className="font16 textBreak">
                {details?.createdAt
                  ? dateFormate(details?.createdAt, "DD MMM YYYY")
                  : "Not Available"}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CustomerSubHeaderDetails;